import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Sell Your Gold"}
                  <span>{props.data ? props.data.highlight : "Get Best Prices"}</span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Get instant cash for your gold jewelry, coins & bars. Transparent evaluation, fair market rates, and immediate payment."}</p>
                <a
                  href="#contact"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Contact Us
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
